<div class="modal-form container">
    <h2 mat-dialog-title class="jumbotron-heading text-center">Edit PPE Origination ID</h2>
    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

        <div class="edit">
            <form [formGroup]="originatorForm">
                <div class="row">
                    <div class="col-12">
                        <mat-form-field appearance="outline" floatLabel="always">
                            <mat-label>PPE Origination ID</mat-label>
                            <input type="text" matInput formControlName="originatorIndex" required>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog-actions" align="end">
        <button mat-stroked-button class="btn btn-secondary" (click)="onCancel()">
            Cancel
        </button>
        <button mat-stroked-button class="btn btn-primary" (click)="onSave()" [disabled]="!originatorForm.valid">
            Save
        </button>
    </mat-dialog-actions>
</div>
